export const moveNewProductToBottom = (products) => {
    const safeProducts = products.filter((product) => Boolean(product));
    return [
        ...safeProducts.filter(p => !p.newProduct),
        ...safeProducts.filter(p => p.newProduct),
    ];
};
